export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-500-3b13b320e2666a42bc097e41d3875428.svg";